var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.color)?_c('span',{staticClass:"team-color-dot",style:({ backgroundColor: _vm.color, width: _vm.size + 'px', height: _vm.size + 'px' })}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }